@if (file(); as file) {
  @if (file.url) {
    <a [href]="file.url" bgoOpenNewTab>
      <div class="thumbnail grid items-center justify-center">
        <fa-icon [icon]="icon()" size="5x"></fa-icon>
      </div>
    </a>
  } @else {
    <div class="thumbnail grid items-center justify-center">
      <fa-icon [icon]="icon()" size="5x"></fa-icon>
    </div>
  }
}
